import { AnswerSummary } from 'cccisd-laravel-appdefs/dist/reportTemplates';

export default [AnswerSummary];
